import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { StarIcon, MapPinIcon } from 'lucide-react';
export function TestimonialSection() {
  const testimonials = [{
    quote: 'Desde que tengo el pack nunca más dudé frente a un alumno. Antes improvisaba. Ahora tengo el criterio para responder cualquier pregunta.',
    name: 'Mariana G.',
    role: 'Profesora de Ed. Física',
    city: 'Buenos Aires',
    initials: 'MG'
  }, {
    quote: 'Lo uso antes de cada clase. En 5 minutos tengo todo lo que necesito saber sobre el ejercicio que voy a dar.',
    name: 'Lucas R.',
    role: 'Entrenador Personal',
    city: 'Córdoba',
    initials: 'LR'
  }, {
    quote: 'Finalmente tengo el respaldo técnico que me faltaba. Mis alumnos notan la diferencia desde la primera clase.',
    name: 'Florencia M.',
    role: 'Profesora de Ed. Física',
    city: 'Rosario',
    initials: 'FM'
  }, {
    quote: 'Lo que más valoro es que está todo organizado. No tengo que buscar nada. Todo ya está listo y ordenado para usar.',
    name: 'Diego S.',
    role: 'Instructor de Musculación',
    city: 'Mendoza',
    initials: 'DS'
  }, {
    quote: 'Como entrenador lo que más me cambió fue poder justificar cada ejercicio con criterio profesional real. Sin dudar.',
    name: 'Javier L.',
    role: 'Entrenador Personal',
    city: 'Santa Fe',
    initials: 'JL'
  }, {
    quote: 'Pensé que iba a ser material genérico. Pero el nivel técnico es exactamente lo que necesitaba en mi práctica diaria.',
    name: 'Carla P.',
    role: 'Entrenadora Personal',
    city: 'Buenos Aires',
    initials: 'CP'
  }, {
    quote: 'Lo recomendé a tres colegas. Todos dicen lo mismo: no sabían que necesitaban esto hasta que lo tuvieron.',
    name: 'Sebastián V.',
    role: 'Profesor de Ed. Física',
    city: 'Tucumán',
    initials: 'SV'
  }, {
    quote: 'El atlas de selección me cambió la forma de armar las sesiones. Ahora elijo cada ejercicio con criterio real.',
    name: 'Jimena L.',
    role: 'Entrenadora Personal',
    city: 'Córdoba',
    initials: 'JL'
  }, {
    quote: 'En menos de una hora tenía todo claro. El material es directo, técnico y aplicable desde el primer día.',
    name: 'Andrés M.',
    role: 'Instructor de Musculación',
    city: 'Mendoza',
    initials: 'AM'
  }];
  return <section className="py-12 bg-background-dark border-y border-card-border-dark" data-id="element-343">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-344">
        <FadeIn className="text-center mb-10" data-id="element-345">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white font-heading mb-2" data-id="element-346">
            Lo que dicen los profesionales
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-black text-primary font-heading" data-id="element-347">
            que ya tienen su Base Técnica:
          </h3>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-348">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.1 * (index % 3)} direction="up" data-id="element-349">
              <div className="bg-card-dark border border-primary/30 rounded-2xl p-6 h-full flex flex-col hover:border-primary/60 transition-colors" data-id="element-350">
                <div className="flex gap-1 mb-6" data-id="element-351">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-352" />)}
                </div>

                <div className="flex items-center gap-4 mb-6" data-id="element-353">
                  <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center text-black font-bold text-lg shrink-0" data-id="element-354">
                    {testimonial.initials}
                  </div>
                  <div data-id="element-355">
                    <h4 className="font-bold text-white text-lg" data-id="element-356">
                      {testimonial.name}
                    </h4>
                    <div className="flex items-center gap-1 text-xs text-gray-400 mt-1" data-id="element-357">
                      <MapPinIcon className="w-3 h-3" data-id="element-358" />
                      <span data-id="element-359">
                        {testimonial.role} — {testimonial.city}
                      </span>
                    </div>
                  </div>
                </div>

                <p className="text-white text-lg leading-relaxed flex-1" data-id="element-360">
                  {testimonial.quote}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}